const KEY = "lumina_purchases";

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch (_) {
    return {};
  }
};

export const getPurchaseSession = (ebookId) => read()[ebookId] || "";

export const getAllPurchases = () => read();

export const savePurchase = (ebookId, sessionId) => {
  const all = read();
  all[ebookId] = sessionId;
  localStorage.setItem(KEY, JSON.stringify(all));
};

export const isPurchased = (ebookId) => !!getPurchaseSession(ebookId);
